import React from 'react';
import { useSelector } from 'react-redux';

const AlertError = ({ message }) => {
    return (
        <div className="alert alert-danger" role="alert">
            {message}
        </div>
    )
}

export default AlertError;
